exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Feedback__root___277Yk form {\n  max-width: 38.13rem;\n}\n\n.Feedback__row___ZpMIj {\n  margin-top: 1.25rem;\n}\n\n.Feedback__submit___1ttee {\n  margin-top: 2.75rem;\n\n  height: 4rem;\n  width: 13.19rem;\n  border-radius: 32px;\n}\n\n.Feedback__title___2yVzk {\n  margin-top: 0;\n  line-height: normal;\n}\n\n@media (max-width: 60em) {\n  .Feedback__root___277Yk form {\n    max-width: 100%;\n  }\n\n  .Feedback__row___ZpMIj {\n    margin-top: 2.313rem;\n  }\n\n  .Feedback__submit___1ttee {\n    margin-top: 3.313rem;\n\n    height: 2.313rem;\n    width: 7rem;\n    border-radius: 2rem;\n  }\n}", ""]);

// exports
exports.locals = {
	"root": "Feedback__root___277Yk",
	"row": "Feedback__row___ZpMIj",
	"submit": "Feedback__submit___1ttee",
	"title": "Feedback__title___2yVzk"
};